import { Button } from "@aiw/ui";
import { useState, type FormEvent } from "react";
import { requestEmailSignIn, signInWithMicrosoft } from "../lib/auth";

export function SignIn() {
  const [email,setEmail]=useState("");
  const [busy,setBusy]=useState(false);
  const [sent,setSent]=useState(false);
  const [error,setError]=useState("");
  async function sendLink(e:FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if(busy)return;
    setBusy(true);setError("");setSent(false);
    try { await requestEmailSignIn(email); setSent(true); }
    catch { setError("The sign-in link could not be sent. Check the email address or contact your administrator."); }
    finally { setBusy(false); }
  }
  return (
    <main className="grid min-h-screen place-items-center bg-background">
      <div className="w-full max-w-sm rounded-lg border bg-card p-6 text-center">
        <img src="/brand/artemis-lockup-on-light.svg" alt="Artemis Flooring" width={300} height={56} className="mx-auto h-11 w-auto" />
        <h1 className="mt-4 text-xl font-semibold">Artemis CRM</h1>
        <p className="mt-1 text-sm text-muted-foreground">Sign in with your authorised account.</p>
        <Button className="mt-4 w-full" onClick={() => void signInWithMicrosoft()}>Sign in with Microsoft</Button>
        <div className="my-4 text-sm text-muted-foreground">or</div>
        <form className="grid gap-3 text-left" onSubmit={sendLink}>
          <label htmlFor="signin-email" className="text-sm font-medium">Email address</label>
          <input id="signin-email" className="w-full rounded-md border bg-background px-3 py-2 text-sm" type="email" autoComplete="email" required value={email} onChange={e=>setEmail(e.target.value)} />
          <Button type="submit" variant="outline" disabled={busy}>{busy ? "Sending…" : "Email me a sign-in link"}</Button>
        </form>
        {sent&&<p role="status" className="mt-3 text-sm">Check your email for a sign-in link.</p>}
        {error&&<p role="alert" className="mt-3 text-sm text-destructive">{error}</p>}
      </div>
    </main>
  );
}
